
    <div class="btn-group col-12" role="group" aria-label="Donation cadence">
      <button
        *ngFor="let p of plans"
        type="button"
        class="btn py-2"
        [class.btn-primary]="value === p.id"
        [class.btn-outline-secondary]="value !== p.id"
        [disabled]="disabledPlanIds?.includes(p.id)"
        (click)="select(p.id)"
      >
        {{ p.label | translate }}
      </button>
    </div>